import { css, Theme } from '@emotion/react'
import {
  accordionClasses,
  accordionSummaryClasses,
  alpha,
  buttonBaseClasses,
  formHelperTextClasses,
  outlinedInputClasses,
} from '@mui/material'
import { scaleBorderRadius } from 'theme/utils'

export const label = (theme: Theme) => css`
  font-weight: 400;
  color: ${theme.typographyColors.typographyThree};
`

export const accordion = (theme: Theme) => css`
  margin: ${theme.spacing(3, 0, 0)};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};
  box-shadow: 0px 2px 2px -1px ${alpha(theme.colors.typographyThree, 0.21)};

  &.${accordionClasses.expanded} {
    margin: ${theme.spacing(3, 0, 0)};

    :first-of-type {
      margin-top: ${theme.spacing(1.25)};
    }
  }

  .${buttonBaseClasses.focusVisible} {
    background-color: transparent;
  }

  :first-of-type {
    margin-top: ${theme.spacing(1.25)};
    border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};
  }

  :last-of-type {
    border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};
  }

  :before {
    display: none;
  }
`

export const FAQ_TYPE_SELECT_CLASSNAME = 'faq-type-select'

export const accordionSummary = (theme: Theme) => css`
  & .${accordionSummaryClasses.content} {
    & .${accordionSummaryClasses.expanded} {
      margin: ${theme.spacing(1.5, 0)};
    }

    align-items: center;
  }

  .${accordionSummaryClasses.content}.${accordionSummaryClasses.expanded} {
    margin: ${theme.spacing(1.5, 0)};
  }

  &.${accordionSummaryClasses.focusVisible} {
    background: transparent;
  }

  .${FAQ_TYPE_SELECT_CLASSNAME} {
    flex-shrink: 0;
    width: 168px;
    margin: ${theme.spacing(0, 1.25)};

    .${buttonBaseClasses.root} {
      height: 44px;
    }
  }
`

export const accordionError = (theme: Theme) => css`
  border: 1px solid ${theme.colors.red};

  .text-editor {
    border-color: ${theme.colors.red};
  }
`

export const accordionDetails = css`
  padding: 0;

  .${formHelperTextClasses.root} {
    display: none;
  }
`

export const editor = css`
  .text-editor {
    border-radius: 0 0 14px 14px;
    margin: 0 -1px -1px;
  }
`

export const questionInput = (theme: Theme) => css`
  flex: 1;
  min-width: 0;

  margin-left: ${theme.spacing(1.25)};

  .${outlinedInputClasses.root} {
    padding: ${theme.spacing(1.5)};
    height: 44px;
  }

  .${formHelperTextClasses.root} {
    display: none;
  }
`

export const iconChevron = (theme: Theme) => css`
  transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
`

export const iconChevronOpen = css`
  transform: rotate(180deg);
`

export const addContentButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(3)};
  width: 100%;
`

export const actionButtonsWrapper = (theme: Theme) => css`
  display: flex;
  justify-content: flex-end;
  column-gap: ${theme.spacing(1.25)};

  margin-top: ${theme.spacing(3)};
`

export const actionButton = css`
  width: 215px;
  height: 48px;
`
